import "@zenlayer/zen-design/esm/message/style";
import _message from "@zenlayer/zen-design/esm/message";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import t from '@zenlayer/zen-intl18';
import Bowser from 'bowser';
/**
 * 根据浏览器类型和支持程度来打开新窗口，并提供处理成功和失败情况的方法
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var WindowOpen = /*#__PURE__*/function () {
  function WindowOpen(url) {
    _classCallCheck(this, WindowOpen);

    _defineProperty(this, "isValidBrowser", Bowser.getParser(window.navigator.userAgent).satisfies({
      chrome: '>0',
      safari: '>=16',
      firefox: '>=82'
    }));

    _defineProperty(this, "win", null);

    if (this.isValidBrowser) {
      if (url) {
        this.validBrowserOpen(url);
      } else {
        this.validBrowserOpen('/redirect');
      }
    } else {
      if (url) {
        this.open(url);
      } else {//不做处理，在successThen时候直接open
      }
    }
  }

  _createClass(WindowOpen, [{
    key: "open",
    value: //普通打开
    function open(url) {
      window.open(url, '_blank');
    } //可用浏览器的打开

  }, {
    key: "validBrowserOpen",
    value: function validBrowserOpen(url) {
      this.win = window.open(url, '_blank');

      if (this.win === null) {
        _message.error({
          content: /*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx("span", {
              children: t('yeMZcyxiSn6s')
            }), /*#__PURE__*/_jsx("a", {
              href: url,
              target: "_black",
              children: url
            })]
          }),
          duration: 10
        });
      } else {
        var _this$win;

        (_this$win = this.win) === null || _this$win === void 0 ? void 0 : _this$win.focus();
      }
    }
  }, {
    key: "successThen",
    value: function successThen(url) {
      if (!!this.win) {
        this.win.location.href = url;
      } else {
        this.open(url);
      }
    }
  }, {
    key: "errorThen",
    value: function errorThen() {
      if (!!this.win) {
        this.win.location.href = '/error?code=404';
      } else {
        this.open('/error?code=404');
      }
    }
  }]);

  return WindowOpen;
}();

export default WindowOpen;